export var eligibilityDetailsMapper = function (data) {
    var result = {
        fundingList: [],
        crollSellList: [],
    };
    if (data && data.length > 0) {
        data.map(function (item) {
            var itemObj = {
                PRODUCTTYPE: item.producttype,
                PRODUCTNAME: item.productname,
                PREAPPROVELOAN: item.preapproveloan,
                NMLIMIT: item.nmlimit,
                UWLIMIT: item.uwlimit,
                ACTYPEFLAG: item.actypeflag,
            };
            if (item.producttype === "1") {
                result.fundingList.push(itemObj);
            }
            else if (item.producttype === "2") {
                result.crollSellList.push(itemObj);
            }
        });
    }
    return result;
};
